import { Check } from "lucide-react";

const GROUPS = ["Classic", "Genre", "Color"];
const GROUP_LABEL = { Classic: "Classic", Genre: "Genre", Color: "Colour schemes" };

const Swatch = ({ t, on, suggested, onPick }) => (
  <button type="button" onClick={() => onPick(t.key)} data-testid={`export-theme-${t.key}`} title={t.label}
    className={`group shrink-0 text-left transition-transform duration-150 hover:-translate-y-0.5 ${on ? "" : "opacity-80 hover:opacity-100"}`}>
    <div className={`relative h-16 w-12 rounded-sm border p-1.5 ${on ? "border-[#F59E0B] ring-2 ring-[#F59E0B]/40" : "border-[#2D3442]"}`} style={{ background: t.bg }}>
      <div className="h-1 w-6 rounded-full" style={{ background: t.accent }} />
      <div className="mt-1.5 font-display text-sm leading-none" style={{ color: t.ink }}>Aa</div>
      <div className="mt-1.5 h-2 w-full rounded-[1px]" style={{ background: t.box }} />
      {on && <Check className="absolute -right-1.5 -top-1.5 h-4 w-4 rounded-full bg-[#F59E0B] p-0.5 text-[#0B0E14]" />}
    </div>
    <div className={`mt-1 w-[68px] text-[11px] leading-tight ${on ? "text-[#F59E0B]" : "text-[#A8A090]"}`}>{t.label}</div>
    {suggested && <div className="text-[9px] uppercase tracking-wider text-[#C4B5FD]" data-testid={`export-theme-suggested-${t.key}`}>suggested</div>}
  </button>
);

export const ThemePicker = ({ themes, value, suggested, onChange }) => (
  <div className="flex gap-6 overflow-x-auto pb-1 lf-scroll" data-testid="export-theme-picker">
    {GROUPS.map((g) => (
      <div key={g} className="shrink-0">
        <div className="lf-label mb-1.5">{GROUP_LABEL[g]}</div>
        <div className="flex items-start gap-2.5">
          {themes.filter((t) => t.group === g).map((t) => <Swatch key={t.key} t={t} on={value === t.key} suggested={suggested === t.key} onPick={onChange} />)}
        </div>
      </div>
    ))}
  </div>
);
